export const fiscalTest = {
	testing: "Test fiscal data {{count}}",
	testingMessage: "Testing {{count}} selected product(s)...",
	successTitle: "Test fiscal data {{count}}",
	successMessage: "All products were tested successfully!",
	successMainText: "Fiscal data tested successfully",
	successSubText: "No errors were found in the presented data",
	errorTitle: "Test fiscal data {{count}}",
	errorMessage: "Oops... Something didn't go as planned.",
	errorSubMessage: "We found errors in the presented fiscal data",
	errorMainText: "Oops... Something didn't go as planned.",
	errorSubText: "We found errors in the presented fiscal data",
	success: "Fiscal data tested successfully",
	error: "Error testing fiscal data",
	unknownError: "Unknown error",
};
